import { render, staticRenderFns } from "./AppSidenav.vue?vue&type=template&id=a33c089e&scoped=true"
import script from "./AppSidenav.vue?vue&type=script&lang=js"
export * from "./AppSidenav.vue?vue&type=script&lang=js"
import style0 from "./AppSidenav.vue?vue&type=style&index=0&id=a33c089e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c089e",
  null
  
)

export default component.exports